import { render, staticRenderFns } from "./HailingDetailTable.vue?vue&type=template&id=1351e480&scoped=true&lang=pug"
import script from "./HailingDetailTable.vue?vue&type=script&lang=js"
export * from "./HailingDetailTable.vue?vue&type=script&lang=js"
import style0 from "./HailingDetailTable.vue?vue&type=style&index=0&id=1351e480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351e480",
  null
  
)

export default component.exports